import React from 'react';
const links = ['Privacy Policy', 'Terms of Service', 'Contact Us'];
export function SiteFooter() {
  return <footer className="w-full bg-surface" data-id="element-195" data-mp="3r9apzhfo3o09">
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-5 sm:py-12" data-id="element-196" data-mp="3racbkfub7sw8">
        <div className="grid grid-cols-1 gap-6 sm:gap-8 md:grid-cols-[1.2fr_0.8fr] md:items-start" data-id="element-197" data-mp="3mg82nr1hhasi">
          <div data-id="element-198" data-mp="3hhwvxp6hjgei">
            <p className="font-display text-lg font-semibold text-ink sm:text-xl" data-id="element-199" data-mp="3hi6e4qlagj9n">TeachersKit™</p>
            <p className="mt-2 text-sm text-ink-soft" data-id="element-200" data-mp="3di5yx3qd841j">
              The complete “Print &amp; Go” system for piano and guitar teachers.
            </p>
            <p className="mt-1 text-sm text-ink-muted" data-id="element-201" data-mp="33hvjdcguykj7">
              Because teaching music shouldn’t cost you every Sunday of the year.
            </p>
          </div>
          <nav aria-label="Footer" data-id="element-202" data-mp="11rbpw1osnqbm">
            <ul className="flex flex-wrap gap-x-5 gap-y-2 md:justify-end" data-id="element-203" data-mp="11rk17p59qnkp">
              {links.map(link => <li key={link} data-id="element-204" data-mp="wtijp8nhqwbc">
                  <a href="#" className="text-sm text-ink-muted transition-colors duration-150 ease-expo hover:text-ink" data-id="element-205" data-mp="wq4lmclv199p">
                    {link}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>

        <p className="mt-8 border-t border-line pt-5 text-[10px] font-medium uppercase tracking-[0.14em] text-ink-muted sm:mt-10 sm:pt-6 sm:text-xs" data-id="element-206" data-mp="10rse2aivxxm0">
          © 2026 TeachersKit™ — All rights reserved.
        </p>
      </div>
    </footer>;
}